import React from 'react';
import Select from 'react-select';
import { NoOptionsMessage, OptionBox, OptionsBox, OptionsListBox } from './components/OptionsBox';
import { IndicatorSeparator } from './components/IndicatorSeparator';
import { DropdownIndicatorBox } from './components/dropdownIndicatorBox';
import { SelectBoxControl, SelectBoxValueContainer } from './components/selectBoxControl';
export var SelectBox = function (props) {
    var valueName = props.valueName, options = props.options, placeholder = props.placeholder, isSearch = props.isSearch, onChange = props.onChange, value = props.value, className = props.className;
    var getOptionValue = function (option) { return option.identifier; };
    var getOptionName = function (option) {
        return option[valueName !== null && valueName !== void 0 ? valueName : 'name'];
    };
    return (React.createElement(Select, { className: className, value: value, classNamePrefix: 'bg', placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : 'Choose variant', components: {
            Menu: OptionsBox,
            ValueContainer: SelectBoxValueContainer,
            IndicatorSeparator: IndicatorSeparator,
            DropdownIndicator: DropdownIndicatorBox,
            Option: OptionBox,
            MenuList: OptionsListBox,
            Control: SelectBoxControl,
            NoOptionsMessage: NoOptionsMessage
        }, isSearchable: isSearch, getOptionLabel: getOptionName, getOptionValue: getOptionValue, options: options !== null && options !== void 0 ? options : [], onChange: onChange }));
};
//# sourceMappingURL=SelectBox.js.mapimport React from 'react';
import Select from 'react-select';
import { NoOptionsMessage, OptionBox, OptionsBox, OptionsListBox } from './components/OptionsBox';
import { IndicatorSeparator } from './components/IndicatorSeparator';
import { DropdownIndicatorBox } from './components/dropdownIndicatorBox';
import { SelectBoxControl, SelectBoxValueContainer } from './components/selectBoxControl';
export var SelectBox = function (props) {
    var valueName = props.valueName, options = props.options, placeholder = props.placeholder, isSearch = props.isSearch, onChange = props.onChange, value = props.value, className = props.className;
    var getOptionValue = function (option) { return option.identifier; };
    var getOptionName = function (option) {
        return option[valueName !== null && valueName !== void 0 ? valueName : 'name'];
    };
    return (React.createElement(Select, { className: className, value: value, classNamePrefix: 'bg', placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : 'Choose variant', components: {
            Menu: OptionsBox,
            ValueContainer: SelectBoxValueContainer,
            IndicatorSeparator: IndicatorSeparator,
            DropdownIndicator: DropdownIndicatorBox,
            Option: OptionBox,
            MenuList: OptionsListBox,
            Control: SelectBoxControl,
            NoOptionsMessage: NoOptionsMessage
        }, isSearchable: isSearch, getOptionLabel: getOptionName, getOptionValue: getOptionValue, options: options !== null && options !== void 0 ? options : [], onChange: onChange }));
};
//# sourceMappingURL=SelectBox.js.map